import * as marketConst from 'constants/gia_ca_thi_truong';
import { toastError } from 'helpers/toastHelper';
import { checkLoadMore } from 'lib';
const initialState = {
  listMarketPrices: {
    data: [],
    error: null,
    isLoading: false,
    isLoadMore: false,
  },
  marketDetail: {
    data: [],
    error: false,
    isLoading: false,
    isEmpty: false,
    market_place: {},
  },
  followingMarketPrice: {
    data: [],
    catalogue_response: [],
    isLoading: false,
    isLoadMore: false,
    error: null,
  },
  leftSidebarMarketPrice: {
    data: [],
    isLoading: false,
    error: null,
  },
  listMarketPricesByCatalogue: {
    data: [],
    error: null,
    isLoading: false,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case marketConst.FETCH_ALL_MARKET_PRICES: {
      return {
        ...state,
        listMarketPrices: {
          data: initialState.listMarketPrices.data,
          isLoading: true,
          error: null,
          isLoadMore: true,
        },
      };
    }

    case marketConst.FETCH_ALL_MARKET_PRICES_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        listMarketPrices: {
          data: data.data,
          isLoading: false,
          error: null,
          isLoadMore: checkLoadMore(data),
        },
      };
    }

    case marketConst.FETCH_ALL_MARKET_PRICES_FAILED: {
      const { error } = action.payload;
      toastError(error);
      return {
        ...state,
        listMarketPrices: {
          data: initialState.listMarketPrices.data,
          isLoading: false,
          isLoadMore: false,
          error: error,
        },
      };
    }

    case marketConst.FETCH_MARKET_PRICES_BY_CATALOGUE: {
      return {
        ...state,
        listMarketPricesByCatalogue: {
          data: initialState.listMarketPricesByCatalogue.data,
          isLoading: true,
          error: null,
        },
      };
    }

    case marketConst.FETCH_MARKET_PRICES_BY_CATALOGUE_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        listMarketPricesByCatalogue: {
          data: data.data,
          isLoading: false,
          error: null,
        },
      };
    }

    case marketConst.FETCH_MARKET_PRICES_BY_CATALOGUE_FAILED: {
      const { error } = action.payload;
      toastError(error);
      return {
        ...state,
        listMarketPricesByCatalogue: {
          data: initialState.listMarketPricesByCatalogue.data,
          isLoading: false,
          error: error,
        },
      };
    }

    case marketConst.FETCH_SIDEBAR_MARKET_PRICES: {
      return {
        ...state,
        leftSidebarMarketPrice: {
          data: initialState.listMarketPrices.data,
          isLoading: true,
          error: null,
        },
      };
    }

    case marketConst.FETCH_SIDEBAR_MARKET_PRICES_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        leftSidebarMarketPrice: {
          data: data.data,
          isLoading: false,
          error: null,
        },
      };
    }

    case marketConst.FETCH_SIDEBAR_MARKET_PRICES_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
      };
    }
    case marketConst.FETCH_MARKET_PRICES: {
      return {
        ...state,
        marketDetail: {
          ...state.marketDetail,
          isLoading: true,
        },
      };
    }
    case marketConst.FETCH_MARKET_PRICES_SUCCESS: {
      const { data } = action.payload;
      if (data.data.length > 0 || Object.keys(data.market_place || {}).length > 0) {
        return {
          ...state,
          marketDetail: {
            ...state.marketDetail,
            data: data.data,
            error: false,
            isLoading: false,
            isEmpty: false,
            market_place: data.market_place,
          },
        };
      } else {
        return {
          ...state,
          marketDetail: {
            ...state.marketDetail,
            error: false,
            isLoading: false,
            isEmpty: true,
            market_place: data.market_place,
          },
        };
      }
    }
    case marketConst.FETCH_MARKET_PRICES_FAILED: {
      const { error } = action.payload;
      toastError('Không tìm thấy giá');
      return {
        ...state,
        marketDetail: {
          ...state.marketDetail,
          isLoading: false,
          isEmpty: true,
          error: null,
        },
      };
    }

    case marketConst.FETCH_LOAD_MORE_MARKET_PRICES: {
      return {
        ...state,
        listMarketPrices: {
          data: state.listMarketPrices.data,
          isLoading: true,
          isLoadMore: false,
          error: null,
        },
      };
    }

    case marketConst.FETCH_LOAD_MORE_MARKET_PRICES_SUCCESS: {
      const { data } = action.payload.data;
      const isLoadMore = data.length > 0;
      return {
        ...state,
        listMarketPrices: {
          data: [...state.listMarketPrices.data, ...data],
          isLoading: false,
          isLoadMore: isLoadMore,
          error: null,
        },
      };
    }

    case marketConst.FETCH_LOAD_MORE_MARKET_PRICES_FAILED: {
      const { error } = action.payload;
      toastError(error);
      return {
        ...state,
        listMarketPrices: {
          data: initialState.listMarketPrices.data,
          isLoading: false,
          isLoadMore: false,
          error: error,
        },
      };
    }

    case marketConst.FETCH_FOLLOWING_MARKET_PRICE: {
      return {
        ...state,
        followingMarketPrice: {
          data: initialState.followingMarketPrice.data,
          catalogue_response: state.followingMarketPrice?.catalogue_response ?? [],
          isLoading: true,
          isLoadMore: true,
          error: null,
        },
      };
    }

    case marketConst.FETCH_FOLLOWING_MARKET_PRICE_SUCCESS: {
      const { data, catalogue_response } = action.payload;
      const safeData = Array.isArray(data) ? data : [];
      return {
        ...state,
        followingMarketPrice: {
          data: safeData,
          catalogue_response: catalogue_response,
          isLoading: false,
          isLoadMore: false,
          error: null,
        },
      };
    }

    case marketConst.LIKE_MARKET_PRICE: {
      return {
        ...state,
      };
    }

    case marketConst.LIKE_MARKET_PRICE_SUCCESS: {
      const { data } = action.payload;
      const likedId = data.data.likeable_id;

      return {
        ...state,
        listMarketPricesByCatalogue: {
          ...state.listMarketPricesByCatalogue,
          data: state.listMarketPricesByCatalogue.data.map(catalogue => {
            const updatedMarkets = catalogue.list_market_prices.map(market => {
              if (market.id === likedId) {
                return {
                  ...market,
                  user_liked: true,
                };
              }
              return market;
            });

            return {
              ...catalogue,
              list_market_prices: updatedMarkets,
            };
          }),
        },

        listMarketPrices: {
          ...state.listMarketPrices,
          data: state.listMarketPrices.data.map(market => {
            if (market.id === likedId) {
              return {
                ...market,
                user_liked: true,
              };
            }
            return market;
          }),
        },

        marketDetail: {
          ...state.marketDetail,
          market_place: {
            ...state.marketDetail.market_place,
            user_liked: true,
          },
        },
      };
    }

    case marketConst.LIKE_MARKET_PRICE_FAILED: {
      const { error } = action.payload;
      const { data: message } = error;
      toastError(message);
      break;
    }

    case marketConst.DISLIKE_MARKET_PRICE: {
      return {
        ...state,
      };
    }

    case marketConst.DISLIKE_MARKET_PRICE_SUCCESS: {
      const { data } = action.payload;
      const dislikedId = data.marketPriceId;

      const updatedFollowingData = state.followingMarketPrice.catalogue_response.reduce((acc, catalogue) => {
        // Lọc bỏ market có id === dislikedId
        const filteredMarkets = catalogue.list_market_prices.filter(market => market.id !== dislikedId);

        // Nếu còn market trong catalogue sau khi lọc
        if (filteredMarkets.length > 0) {
          acc.push({
            ...catalogue,
            list_market_prices: filteredMarkets,
          });
        }

        return acc;
      }, []);

      return {
        ...state,
        listMarketPricesByCatalogue: {
          ...state.listMarketPricesByCatalogue,
          data: state.listMarketPricesByCatalogue.data.map(catalogue => {
            const updatedMarkets = catalogue.list_market_prices.map(market => {
              if (market.id === dislikedId) {
                return {
                  ...market,
                  user_liked: false,
                };
              }
              return market;
            });

            return {
              ...catalogue,
              list_market_prices: updatedMarkets,
            };
          }),
        },

        listMarketPrices: {
          ...state.listMarketPrices,
          data: state.listMarketPrices.data.map(market => {
            if (market.id === dislikedId) {
              return {
                ...market,
                user_liked: false,
              };
            }
            return market;
          }),
        },

        marketDetail: {
          ...state.marketDetail,
          market_place: {
            ...state.marketDetail.market_place,
            user_liked: false,
          },
        },

        followingMarketPrice: {
          ...state.followingMarketPrice,
          catalogue_response: state.followingMarketPrice.catalogue_response.reduce((acc, catalogue) => {
            const filteredMarkets = catalogue.list_market_prices.filter(market => market.id !== dislikedId);

            if (filteredMarkets.length > 0) {
              acc.push({
                ...catalogue,
                list_market_prices: filteredMarkets,
              });
            }

            return acc;
          }, []),
        },
      };
    }

    default:
      return state;
  }
};
export default reducer;
